define('views/components/product_info/info',['require','backbone','text!templates/components/product_info/info.html'],function (require) {
  var Backbone = require("backbone");

  var temp = require("text!templates/components/product_info/info.html");

  return Backbone.Marionette.ItemView.extend({
    tagName: "div",
    template: _.template(temp),
    className: "product-info",

    ui: function () {
      return {
        deleteButton: "#info-delete-button",
        saveButton: "#info-submit-button",
      };
    },

    events: {
      "click @ui.deleteButton": "deleteButtonClicked",
      "click @ui.saveButton": "saveButtonClicked",

      "change form input": "formChanged",
    },

    formChanged: function (event) {
      var value = $(event.currentTarget).val();
      this.model.set('key', value);
    },

    deleteButtonClicked : function(){
      var _this = this;
      if(this.model.get('id') == null){
        _this._deleteInfo();
      }else{
        App.utils.showConfirmModal(App.polyglot.t('delete_product_info_confirm_message'), function () {
          _this._deleteInfo();
        });
      }

 
    },

    _deleteInfo: function () {

      var _this = this;
      var is_exist = this.model.get('id') != null;
      if(is_exist){
        this.ui.saveButton.addClass("loading");
      }
      

      this.model.destroy({
        success: function() {
          if(is_exist){
            App.utils.showMessage("success", App.polyglot.t("delete_success"));  
          }
        },
        error: function(model, response) {
          _this.ui.saveButton.removeClass("loading");
          // Show error messages
          if (response.responseJSON.errors) {
            for (var i = 0; i < response.responseJSON.errors.length; i++) {
              App.utils.showMessage(
                "error",
                response.responseJSON.errors[i].message
              );
            }
          }
        },
      });
    },

    saveButtonClicked: function () {
      var _this = this;
      this.ui.saveButton.addClass("loading");

      var is_new = this.model.get('id') == null;

      this.model.save(null, {
        success: function () {
          _this.ui.saveButton.removeClass("loading");

          if(is_new){
            App.utils.showMessage("success", App.polyglot.t("create_success"));
            _this.render();
          }else{
            App.utils.showMessage("success", App.polyglot.t("update_success"));
          }
        },
        error: function (model, response) {
          _this.ui.saveButton.removeClass("loading");
          // Show error messages
          if (response.responseJSON.errors) {
            for (var i = 0; i < response.responseJSON.errors.length; i++) {
              App.utils.showMessage(
                "error",
                response.responseJSON.errors[i].message
              );
            }
          }
        },
      });
    },


  });
});

